import React, { Component } from 'react';
import { Button, Card, CardBody, CardText, CardTitle, CardGroup, TabPane } from 'reactstrap';
import { Redirect } from 'react-router';
import cookie from 'react-cookies';
import { defaultCurrency, apiBaseUrl } from '../../../configs/configs';


class CustomBreakup extends Component {

	constructor(props) {
		super(props);

		this.state = {
			redirect: false,
			rows: [{
				name: "Rank 1",
				startRank: 1,
				endRank: 1,
				percentage: 100,
				price: this.props.contestData.winning_amount || 0,
				price_each: this.props.contestData.winning_amount || 0,
				percentage_each: 100,
				winning_not: "false",
				new_price: "",

				nameError: "",
				startRankError: "",
				endRankError: '',
				percentageError: "",
				percentage_eachError: "",
				new_priceError: "",
				isError: false,
			}],
			contestData: this.props.contestData || {},
			totalWinners: 1,
			lastRow: 0,
			totalPercentage: 100,
			totalPrice: this.props.contestData.winning_amount || 0
		};
		this.updateCustomBreakup = this.updateCustomBreakup.bind(this);
		this.validateFields = this.validateFields.bind(this);
		this.checkEmptyOrZero = this.checkEmptyOrZero.bind(this);
	}


	async updateCustomBreakup() {


		var formData = this.state.rows;
		let totalWinners = this.state.totalWinners;
		const response = await this.validateFields(formData);
		let contest_size = this.state.contestData.contest_size;
		if (response) {
			// alert('please fix all errors...');
		} else {

			if (totalWinners > contest_size) {
				alert('total winners size should be less than equal to contest size !');
				return;
			}

			var predefinedData = this.state.rows;
			var type = 1;

			var contest_id = this.state.contestData._id;
			// const requestBody = {
			//   contest_id: contest_id,
			//   rank_name: 'test',
			//   type: type,
			//   breakup: predefinedData,
			//   totalWinners: totalWinners
			// };

			const formData1 = new FormData();

			formData1.append('contest_id', contest_id);
			formData1.append('type', type);
			formData1.append('totalWinners', totalWinners);
			formData1.append('breakup', JSON.stringify(predefinedData));

			const token = cookie.load('token');
			const updateContestBreakupUrl = `${apiBaseUrl}/contests/updatebreakups`;
			const response = await fetch(updateContestBreakupUrl, {
				method: 'POST',
				//body: JSON.stringify(requestBody),
				body: formData1,
				headers: {
					"token": token,
				}
			});
			const responseBody = await response.json();

			if (response.status === 200) {
				this.setState({ alertClass: 'success', alertMessage: 'Breakup updated successfully' });
			} else if (response.status === 409) {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: responseBody.msg });
			} else if (response.status === 403) {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: responseBody.msg });
			} else if (response.status === 404) {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: responseBody.msg });
			} else if (response.status === 400) {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: responseBody.msg });
			} else if (response.status === 422) {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: 'Please provide valid details.' });
			} else {
				this.setState({ redirect: true, alertClass: 'danger', alertMessage: 'Error in Creating Contest.' });
			}
			this.setRedirect();

		}
	}

	async validateFields(formData) {
		const rows = [...this.state.rows];
		var isError = false;
		var totalPercentage = 0;
		for (var key in formData) {
			var formValue = formData[key];
			var oldRow = rows[key];

			if (formValue.name == '') {
				oldRow['nameError'] = "Name is required";
				isError = true;

			} else {

				oldRow['nameError'] = "";
			}

			if (formValue.startRank == '' || formValue.startRank == '0') {
				oldRow['startRankError'] = "Start Rank should greater than 0";
				isError = true;

			} else {
				oldRow['startRankError'] = "";
			}



			if (formValue.endRank == '0' || formValue.endRank < formValue.startRank) {
				oldRow['endRankError'] = "End Rank should greater than 0 or equal";
				isError = true;

			} else {
				oldRow['endRankError'] = "";

			}


			if ((formValue.percentage_each == '' || formValue.percentage_each == '0') && formValue.winning_not === "false") {
				oldRow['percentage_eachError'] = "percentage should greater than 0";
				isError = true;

			} else {
				oldRow['percentage_eachError'] = "";
			}
			
			if (formValue.winning_not === "true" && formValue.new_price === "") {
				oldRow['new_priceError'] = "Please enter price winning note.";
				isError = true;
			} else {
				oldRow['new_priceError'] = "";
			}

			if (formValue.percentage == '' || formValue.percentage == '0') {
				oldRow['percentageError'] = "percentage should greater than 0";
				isError = true;

			} else {
				totalPercentage = totalPercentage + this.priceFloatFixed(formValue.percentage);
				oldRow['percentageError'] = "";
			}

			rows[key] = oldRow;
			this.setState({
				rows
			});


		}

		if (isError) {
			this.setState({
				isError: true
			});
		} else {
			if (totalPercentage > '101' || totalPercentage < '99') {
				alert('Total percentage should be greater than 99 or equal to 100');
				isError = true;
				this.setState({
					isError: true
				});
			}
		}

		return isError;
	}


	setRedirect = () => {
		this.setState({
			redirect: true
		})
	}
	renderRedirect = () => {
		if (this.state.redirect) {
			return <Redirect to={
				{
					pathname: '/contests',
					alert: {
						color: this.state.alertClass,
						message: this.state.alertMessage
					}
				}
			} />
		}
	}
	priceFloatFixed(amount) {
		return +(Math.round(amount + "e+2") + "e-2");
	}

	updatePrice_copy = (percentage, startRank, endRank) => {

		var endRank = parseInt(endRank);
		var startRank = parseInt(startRank);
		var prizeAmount = this.state.contestData.winning_amount;
		if (endRank > startRank) {
			var winnerCount = (endRank - startRank) + 1;
		} else {
			var winnerCount = 1;
		}

		var price = this.priceFloatFixed(((this.priceFloatFixed(percentage) * prizeAmount) / 100) / winnerCount);
		// console.log('updatePrice', percentage, startRank, endRank, winnerCount, price);
		return price;
	}
	updatePercentageTotal = (percentage_each, startRank, endRank) => {

		endRank = parseInt(endRank);
		startRank = parseInt(startRank);
		let percentage = 0;
		let winnerCount = 1;
		if (endRank > startRank) {
			winnerCount = (endRank - startRank) + 1;
		}

		if (!this.checkEmptyOrZero(percentage_each)) {
			percentage = winnerCount * percentage_each;
		}

		return percentage.toFixed(2);
	}
	updatePriceEach = (percentage_each, startRank, endRank) => {

		endRank = parseInt(endRank);
		startRank = parseInt(startRank);
		let prizeAmount = this.state.contestData.winning_amount;
		let price = 0;
		let winnerCount = 1;
		if (endRank > startRank) {
			winnerCount = (endRank - startRank) + 1;
		}


		if (!this.checkEmptyOrZero(percentage_each)) {
			price = this.priceFloatFixed((percentage_each * prizeAmount) / 100);
		}
		// console.log('updatePrice', percentage, startRank, endRank, winnerCount, price);
		return price;
	}

	updatePriceTotal = (priceEach, startRank, endRank) => {
		endRank = parseInt(endRank);
		startRank = parseInt(startRank);
		priceEach = parseFloat(priceEach);
		let price = 0.00;

		let winnerCount = 1;
		if (endRank > startRank) {
			winnerCount = (endRank - startRank) + 1;
		}

		if (!this.checkEmptyOrZero(priceEach)) {
			price = winnerCount * priceEach;
		}
		// this.setState({totalPrice: price});
		return price;
	}

	updateTotalPricePercentage() {
		var totalPercentage = 0;
		let totalPrice = 0;
		var formData = this.state.rows;
		for (var key in formData) {
			var formValue = formData[key];
			totalPercentage = totalPercentage + this.priceFloatFixed(formValue.percentage);
			totalPrice = totalPrice + this.priceFloatFixed(formValue.price);
		}
		this.setState({ totalPercentage: totalPercentage, totalPrice: totalPrice });
	}
	handleChange = idx => e => {
		const { name, value } = e.target;
		const rows = [...this.state.rows];
		// console.log(idx);
		// console.log('old', rows);
		// alert(idx);
		var oldRow = rows[idx];
		oldRow[name] = value;
		//kamal
		// console.log(oldRow);
		if (name === "winning_not" && oldRow['winning_not'] === "true") {
			oldRow["percentage_each"] = 0;
		}

		if (name != 'name') {
			oldRow['price_each'] = this.updatePriceEach(oldRow.percentage_each, oldRow.startRank, oldRow.endRank);
			oldRow['percentage'] = this.updatePercentageTotal(oldRow.percentage_each, oldRow.startRank, oldRow.endRank);
			oldRow['price'] = this.updatePriceTotal(oldRow['price_each'], oldRow.startRank, oldRow.endRank);
		}
		this.updateTotalPricePercentage();

		if (name == 'name') {
			if (value == '') {
				oldRow['nameError'] = "Name is required";
			} else {
				oldRow['nameError'] = "";
			}
		}

		if (name == 'startRank') {
			if (parseInt(oldRow['endRank']) == parseInt(value)) {
				oldRow['name'] = 'Rank ' + value;
			} else {
				oldRow['name'] = 'Rank ' + value + '-' + oldRow['endRank'];
			}


			oldRow['name'] = 'Rank ' + value + '-' + oldRow['endRank'];
			if (value == '' || value == '0') {
				oldRow['startRankError'] = "Start should be greater than 0";
			} else {
				var invalidStartRange = false;
				for (var key in rows) {
					var formValue = rows[key];
					// console.log('key****-----*****', key, idx, value, formValue.startRank, formValue.endRank);
					if (key != idx) {
						if (formValue.endRank == '0') {
							if (formValue.startRank == value) {
								invalidStartRange = true;
								// alert('Invalid range');
							}
						} else {
							if (parseInt(formValue.startRank) <= value && value <= parseInt(formValue.endRank)) {
								invalidStartRange = true;
								// alert('invalid range selected');
							}
						}

					} else {
						console.log('else');
					}

				}
				if (invalidStartRange) {
					oldRow['startRankError'] = "Invalid range selected";
				} else {
					oldRow['startRankError'] = "";
				}
			}
		}

		if (name == 'endRank') {
			if (parseInt(oldRow['startRank']) == parseInt(value)) {
				oldRow['name'] = 'Rank ' + oldRow['startRank'];
			} else {
				oldRow['name'] = 'Rank ' + oldRow['startRank'] + '-' + value;
			}

			if (value != '' && value != '0') {

				this.setState({
					totalWinners: value
				});
				if (value < parseInt(rows[idx].startRank)) {
					oldRow['endRankError'] = "End range should greater than start range";
				} else {
					var invalidEndRange = false;
					for (var key in rows) {
						var formValue = rows[key];
						if (key != idx) {
							if (parseInt(formValue.startRank) <= value && value <= parseInt(formValue.endRank)) {
								invalidEndRange = true;
							}

						}

					}
					if (invalidEndRange) {
						oldRow['endRankError'] = "Invalid range selected";
					} else {
						oldRow['endRankError'] = "";
					}
				}
			} else {
				oldRow['endRankError'] = "";
			}
		}

		if (name == 'percentage') {
			if (value == '' || value == '0') {
				oldRow['percentageError'] = "Invalid percentage";
			} else {
				oldRow['percentageError'] = "";
			}
		}
		if (name === "winning_not" && oldRow['winning_not'] === "true") {
			oldRow['new_priceError'] = "Please enter winning price note";
		} else {
			oldRow['new_priceError'] = "";
		}

		if (name == 'percentage_each') {
			if (value == '' || value == '0') {
				oldRow['percentage_eachError'] = "Invalid percentage";
			} else {
				oldRow['percentage_eachError'] = "";
			}
		}

		rows[idx] = oldRow;

		this.setState({
			rows
		});
	};


	checkEmptyOrZero = (val) => {
		if (val == '0' || val == '') {
			return true;
		}
		return false;
	}

	handleAddRow = () => {
		const rows = [...this.state.rows];

		let lastRow = this.state.lastRow;
		let oldRow = rows[lastRow];
		let isError = false;
		// alert(lastRow);
		// alert(rows[lastRow]['endRank']);
		if (this.checkEmptyOrZero(oldRow['endRank'])) {
			oldRow['endRankError'] = "Invalid end rank";
			isError = true;
		}
		if (this.checkEmptyOrZero(oldRow['percentage_each']) && this.state.rows[this.state.lastRow]['winning_not'] === "false") {
			oldRow['percentage_eachError'] = "percentage should greater than 0";
			isError = true;
		}
		if (isError) {
			rows[lastRow] = oldRow;
			this.setState({ rows });

			return;
		}

		let nextRow = lastRow + 1;
		let nextRowStartRank = parseInt(rows[lastRow]['endRank']) + 1;

		const item = {
			name: "Rank " + nextRowStartRank + " -0",
			startRank: nextRowStartRank,
			endRank: 0,
			percentage: 0,
			price: 0,
			percentage_each: 0,
			price_each: 0,
			winning_not: "false",
			new_price: "",
			
			nameError: "",
			percentageError: "",
			startRankError: "",
			endRankError: '',
			percentage_eachError: "",
		};
		this.setState({
			rows: [...this.state.rows, item],
			lastRow: nextRow
		});
	};

	handleRemoveRow = () => {
		let lastRow = this.state.lastRow;
		if (lastRow > 0) {
			this.setState({
				rows: this.state.rows.slice(0, -1),
				lastRow: lastRow - 1
			});
		}

	};
	handleRemoveSpecificRow = (idx) => () => {
		const rows = [...this.state.rows]
		rows.splice(idx, 1)
		this.setState({ rows })
	}

	render() {
		return (
			<TabPane tabId="2">
				<div>
					{this.renderRedirect()}
					<CardGroup>
						<Card>
							<CardBody>
								<CardTitle></CardTitle>
								<CardText>CONTEST SIZE <br /> {this.props.contestData.contest_size}</CardText>
							</CardBody>
						</Card>

						<Card>
							<CardBody>
								<CardTitle></CardTitle>
								<CardText>
									PRICE POOL <br />
									{defaultCurrency} {this.props.contestData.winning_amount}
								</CardText>
							</CardBody>
						</Card>
						<Card>
							<CardBody>
								<CardTitle></CardTitle>
								<CardText>ENTRY <br />{defaultCurrency} {this.props.contestData.entry_fee}</CardText>
							</CardBody>
						</Card>
					</CardGroup>

					<br />
					<div className="container">
						<div className="row clearfix">
							<div className="col-md-12 column">

								<span
									readOnly="readOnly"
									type="text"
									name="totalWinners"
									value={this.state.totalWinners}
									className="float-right"
								>Total Winners: {this.state.totalWinners}</span>
								<br /><br />
								<table className="table table-bordered table-hover" id="tab_logic" >
									<thead>
										<tr>
											<th className="text-center"> # </th>
											<th className="text-center"> Winning Note </th>
											<th className="text-center"> Price Comment </th>
											<th className="text-center"> Name </th>
											<th className="text-center"> Start Rank </th>
											<th className="text-center"> End Rank </th>
											<th className="text-center"> Percentage (each) </th>
											<th className="text-center"> Price (each) </th>
											<th className="text-center"> Total Percentage ({this.state.totalPercentage}) </th>
											<th className="text-center"> Total Price ({this.state.totalPrice})</th>
										</tr>
									</thead>
									<tbody>
										{this.state.rows.map((item, idx) => (
											<tr id="addr0" key={idx}>
												<td>{idx + 1}</td>
												<td>
													<select type="select" name="winning_not" id="winning_not" value={this.state.rows[idx].winning_not} onChange={this.handleChange(idx)} className="form-control" >
														<option value="true">Active</option>
														<option value="false">In-Active</option>
													</select>
												</td>
												<td>
													<input
														readOnly={this.state.rows[idx].winning_not === "false"}
														type="text"
														name="new_price"
														value={this.state.rows[idx].new_price}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].new_priceError}</span>

												</td>
												<td>
													<input
														type="text"
														name="name"
														value={this.state.rows[idx].name}
														onChange={this.handleChange(idx)}
														className="form-control"
														readOnly={true}
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].nameError}</span>
												</td>
												<td>
													<input
														readOnly="readOnly"
														type="text"
														name="startRank"
														value={this.state.rows[idx].startRank}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].startRankError}</span>

												</td>
												<td>
													<input
														readOnly={this.state.lastRow != idx}
														type="number"
														name="endRank"
														value={this.state.rows[idx].endRank}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].endRankError}</span>
												</td>
												<td>
													<input
														readOnly={this.state.rows[idx].winning_not === "true"}
														type="text"
														name="percentage_each"
														value={this.state.rows[idx].percentage_each}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].percentage_eachError}</span>
												</td>
												<td>
													<input
														readOnly="readOnly"
														type="text"
														name="price_each"
														value={this.state.rows[idx].price_each}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
												</td>
												<td>
													<input
														readOnly="readOnly"
														type="text"
														name="percentage"
														value={this.state.rows[idx].percentage}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
													<span style={{ color: "red" }}>{this.state.rows[idx].percentageError}</span>
												</td>
												<td>
													<input
														readOnly="readOnly"
														type="text"
														name="price"
														value={this.state.rows[idx].price}
														onChange={this.handleChange(idx)}
														className="form-control"
													/>
												</td>

											</tr>
										))}
									</tbody>
								</table>
								{this.state.rows[this.state.lastRow]['winning_not'] === "true" ? 
									<button onClick={this.handleAddRow}
										className="btn btn-primary" disabled={this.state.rows[this.state.lastRow]['endRank'] == '0' || this.state.rows[this.state.lastRow]['endRank'] == ''}>
										Add Row
									</button>
									:
									<button onClick={this.handleAddRow}
										className="btn btn-primary" disabled={this.state.rows[this.state.lastRow]['endRank'] == '0' || this.state.rows[this.state.lastRow]['endRank'] == '' || this.state.rows[this.state.lastRow]['percentage_each'] == '0' || this.state.rows[this.state.lastRow]['percentage_each'] == ''}>
										Add Row
									</button>
								}
								<button onClick={this.handleRemoveRow} disabled={this.state.lastRow == '0'} className="btn btn-danger float-right">
									Delete Last Row
								</button>
							</div>
						</div>
					</div>
					<br />
					<div>
						{/* <Button color="primary" disabled={this.state.isError} onClick={this.updateCustomBreakup}>Update Breakup</Button> */}
						<Button color="primary" onClick={this.updateCustomBreakup}>Update Breakup</Button>
					</div>
				</div>
			</TabPane>

		);
	}
}

export default CustomBreakup;
